import React from 'react';
import './loaderComponent.css';

const ButtonLoaderComponent = ({ importedClassNames = '', headerClass = '' }) => {
  return (
    <div className={`buttonLoaderOuterWrapper ${headerClass}`}>
      <div
        className={`spinner-border l=buttonLoaderWrapper ${importedClassNames}`}
        role='status'
      >
        <span className='sr-only'></span>
      </div>
    </div>
  );
};

export default ButtonLoaderComponent;
